import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api';
import toast from 'react-hot-toast';
import { LogIn } from 'lucide-react';
import { saveAuth } from '../auth';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15);
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 0.65rem 0.8rem;
  font-size: 0.95rem;
  margin-bottom: 1rem;
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.3);
  }
`;

const Button = styled.button`
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-top: 0.5rem;
`;

const FooterText = styled.p`
  font-size: 0.85rem;
  color: #6b7280;
  margin-top: 1rem;
  text-align: center;
`;

const FooterLink = styled(Link)`
  color: #4f46e5;
  font-weight: 600;
  text-decoration: none;
`;

const HelperRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
`;

const HelperLink = styled(Link)`
  font-size: 0.85rem;
  color: #4f46e5;
  font-weight: 600;
  text-decoration: none;
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('E-posta ve şifre gerekli');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email, password });
      saveAuth(res.data.token, res.data.user);
      toast.success('Giriş başarılı');
      navigate('/dashboard');
    } catch (err) {
      const message = err.response?.data?.error || 'Giriş sırasında hata oluştu';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Card>
        <Title>Giriş Yap</Title>
        <Subtitle>İşHazır hesabınla giriş yap ve CV araçlarına eriş.</Subtitle>
        <form onSubmit={handleSubmit}>
          <div>
            <Label>E-posta</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@mail.com"
            />
          </div>
          <div>
            <Label>Şifre</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifre"
            />
          </div>
          <HelperRow>
            <HelperLink to="/forgot-password">Şifremi unuttum</HelperLink>
          </HelperRow>
          <Button type="submit" disabled={loading}>
            <LogIn size={18} />
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </Button>
        </form>
        <FooterText>
          Hesabın yok mu? <FooterLink to="/register">Ücretsiz Kayıt ol</FooterLink>
        </FooterText>
      </Card>
    </PageContainer>
  );
};

export default Login;
